import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import './user-group.scss';
import UserImage from '../user-image/user-image';
// import Popover from '../custom-popover/custom-popover';
import UserCounter from '../user-counter/user-counter';
import AdvancePopover from '../advance-popover/advance-popover';
import {
  AddUserIcon,
  AddUserNewCircleIcon,
  TrashIconFillIcon,
} from '../icons/icons';
import ListOfUser from '../message/userList/userList';
import UserDetails from '../user-details/user-details';
import IconButton from '../icon-button/icon-button';
import MoreParticipants from '../participants-popover/more-participants';
import Dialog from '../dialog/dialog';
import useDialog from '../dialog/useDialog';
import DialogPanel from '../dialog-panel/dialog-panel';
import DialogPanelBody from '../dialog-panel/dialog-panel-body/dialog-panel-body';
import DialogPanelFooter from '../dialog-panel/dialog-panel-footer/dialog-panel-footer';
import NewButton from '../button/newButton';

export default function UserGroup({
  userData,
  infoDirection,
  sliceVal,
  startSliceVal,
  removeTooltip,
  size,
  onAddClick,
  eventID,
  enableAdd,
  newUserData,
  enableHover,
  onExtarnalClick,
  extarnalClick,
  allowRemoveUser,
  handleRemoveUser,
  allowAddUser,
  moreItemsDetails,
  defaultTitle,
}) {
  const [t] = useTranslation('manageorders');
  const [eventValue, setEventValue] = useState();
  const [selectedUsers, setSelectedUsers] = useState([]);
  const popupRef = useRef(null);

  const {
    isShowing: moreParticipantsDialog,
    toggle: toggleMoreParticipantsDialog,
  } = useDialog();

  const togglePopover = (e) => {
    if (moreItemsDetails?.id) toggleMoreParticipantsDialog();
    else setEventValue(e.target);
  };
  const handleClose = () => {
    setEventValue(null);
  };
  // const [addUserEventValue, setAddUserEventValue] = useState();
  const { isShowing: addUserEventValue, toggle: toggleAddUserPopover } =
    useDialog();
  const { isShowing: removeUserEventValue, toggle: toggleRemoveUserPopover } =
    useDialog();
  // const toggleAddUserPopover = (e) => {
  //   setAddUserEventValue(e.target);
  // };
  // const handleCloseAddUserPopover = () => {
  //   setAddUserEventValue(null);
  // };

  useEffect(() => {
    if (!enableAdd && addUserEventValue) {
      toggleAddUserPopover();
    }
  }, [enableAdd]);
  useEffect(() => {
    popupRef.current.focus();
  }, []);
  return (
    <div
      ref={popupRef}
      className={`user-group ${enableHover ? 'enable-hover' : ''} ${
        eventValue || addUserEventValue || removeUserEventValue ? 'active' : ''
      } ${sliceVal === 0 ? 'keep-expanded' : ''}`}
    >
      {userData?.length > 0 &&
        userData?.slice(startSliceVal, sliceVal)?.map((data) => {
          return (
            <UserImage
              path={data?.profilePicture}
              size={size}
              name={`${data?.firstName} ${data?.lastName}`}
              shortName={`${data?.firstName?.[0]}${data?.lastName?.[0]}`?.toUpperCase()}
              email={data?.email}
              verified={data?.emailVerification || true}
              infoDirection={infoDirection}
              removeTooltip={removeTooltip}
            />
          );
        })}
      {userData?.length > sliceVal &&
        !moreItemsDetails?.id &&
        (!extarnalClick ? (
          <UserCounter
            text={
              sliceVal !== 0 ? (
                `${`+${userData.length - sliceVal}`}`
              ) : (
                <AddUserNewCircleIcon color="#fff" />
              )
            }
            counter={sliceVal === 0 && userData.length}
            // onClick={togglePopover}
            onClick={toggleRemoveUserPopover}
            id="userPopover"
            size={size}
          />
        ) : (
          <UserCounter
            text={`${sliceVal !== 0 ? '+' : ''}${userData.length - sliceVal}`}
            // counter
            onClick={onExtarnalClick}
            size={size}
          />
        ))}

      {moreItemsDetails?.count ? (
        <UserCounter
          text={`+${moreItemsDetails?.count}`}
          counter={sliceVal === 0 && userData.length}
          onClick={togglePopover}
          id="userPopover"
          size={size}
        />
      ) : null}

      {enableAdd && (
        <>
          <UserCounter
            text={
              <AddUserIcon color="#ffffff" width="0.972vw" height="0.972vw" />
            }
            // counter
            onClick={toggleAddUserPopover}
            size={size}
            id={eventID}
          />
          <Dialog
            reference="actionPopover"
            isShowing={addUserEventValue}
            hide={() => {
              setSelectedUsers([]);
              toggleAddUserPopover();
            }}
            placement="center"
          >
            <DialogPanel
              title={t('manageordersscreen.chatmenu.add-user.title')}
            >
              <DialogPanelBody className="p-0">
                <ListOfUser
                  users={newUserData}
                  addUserInChannel={onAddClick}
                  allowAddUser={allowAddUser}
                  selectedUsers={selectedUsers}
                  setSelectedUsers={setSelectedUsers}
                />
              </DialogPanelBody>
              <DialogPanelFooter />
              {/* enable for adding bulk participants */}
              {false && (
                <DialogPanelFooter>
                  <NewButton
                    onClick={() => {
                      setSelectedUsers([]);
                      toggleAddUserPopover();
                    }}
                  >
                    {t('manageordersscreen.chatmenu.add-user.cancel')}
                  </NewButton>
                  <NewButton
                    color="primary"
                    onClick={() => onAddClick(selectedUsers)}
                    disabled={!selectedUsers?.length}
                  >
                    {t('manageordersscreen.chatmenu.add-user.invite')}
                  </NewButton>
                </DialogPanelFooter>
              )}
            </DialogPanel>
          </Dialog>
        </>
      )}

      {/* remove this block later */}
      {!moreItemsDetails?.id && false && (
        <AdvancePopover
          reference="userPopover"
          getEvent={eventValue}
          closePopover={handleClose}
        >
          <ul className="action-list user-list">
            {userData?.slice(sliceVal)?.map((user) => {
              return (
                <li>
                  <UserDetails
                    size="medium"
                    profilePic={user?.profilePicture}
                    userName={`${user?.firstName}${user?.lastName}`?.toUpperCase()}
                    userEmail={user?.email}
                  />
                  {allowRemoveUser && (
                    <IconButton
                      onClick={() => {
                        handleRemoveUser(user?.userSub);
                      }}
                      className="action-button"
                    >
                      <TrashIconFillIcon />
                    </IconButton>
                  )}
                </li>
              );
            })}
          </ul>
        </AdvancePopover>
      )}

      {!moreItemsDetails?.id ? (
        <Dialog
          reference="actionPopover"
          isShowing={removeUserEventValue}
          hide={() => {
            setSelectedUsers([]);
            toggleRemoveUserPopover();
          }}
          placement="center"
        >
          <DialogPanel
            title={
              defaultTitle
                ? t('manageordersscreen.participantpopup.title')
                : t('manageordersscreen.chatmenu.remove-user.title')
            }
          >
            <DialogPanelBody className="p-0">
              {!moreItemsDetails?.isMaterialMapping && (
                <ListOfUser
                  users={userData}
                  removeUserFromChannel={handleRemoveUser}
                  allowRemoveUser={allowRemoveUser}
                  selectedUsers={selectedUsers}
                  setSelectedUsers={setSelectedUsers}
                />
              )}
            </DialogPanelBody>
            <DialogPanelFooter />
            {/* enable for adding bulk participants */}
            {false && (
              <DialogPanelFooter>
                <NewButton
                  onClick={() => {
                    setSelectedUsers([]);
                    toggleRemoveUserPopover();
                  }}
                >
                  {t('manageordersscreen.chatmenu.remove-user.cancel')}
                </NewButton>
                <NewButton
                  color="primary"
                  onClick={() => onAddClick(selectedUsers)}
                  disabled={!selectedUsers?.length}
                >
                  {t('manageordersscreen.chatmenu.remove-user.remove')}
                </NewButton>
              </DialogPanelFooter>
            )}
          </DialogPanel>
        </Dialog>
      ) : (
        <Dialog
          placement="center"
          isShowing={moreParticipantsDialog}
          hide={toggleMoreParticipantsDialog}
        >
          <MoreParticipants details={moreItemsDetails} />
        </Dialog>
      )}
    </div>
  );
}
UserGroup.propTypes = {
  userData: PropTypes.arrayOf(),
  newUserData: PropTypes.arrayOf(),
  enableHover: PropTypes.bool,
  infoDirection: PropTypes.string,
  sliceVal: PropTypes.number,
  startSliceVal: PropTypes.number,
  removeTooltip: PropTypes.bool,
  size: PropTypes.string,
  onAddClick: PropTypes.func,
  eventID: PropTypes.string,
  enableAdd: PropTypes.bool,
  onExtarnalClick: PropTypes.func,
  extarnalClick: PropTypes.bool,
  allowRemoveUser: PropTypes.bool,
  handleRemoveUser: PropTypes.func,
  allowAddUser: PropTypes.bool,
  moreItemsDetails: PropTypes.instanceOf(Object),
  isMaterialMapping: PropTypes.bool,
  defaultTitle: PropTypes.bool,
};
UserGroup.defaultProps = {
  userData: [],
  newUserData: [],
  infoDirection: '',
  sliceVal: 2,
  startSliceVal: 0,
  removeTooltip: false,
  size: 'small',
  onAddClick: () => {},
  eventID: '',
  enableAdd: false,
  enableHover: false,
  onExtarnalClick: () => {},
  extarnalClick: false,
  allowRemoveUser: false,
  handleRemoveUser: () => {},
  allowAddUser: false,
  moreItemsDetails: {},
  isMaterialMapping: false,
  defaultTitle: false,
};
